import BoyIcon from '@mui/icons-material/Boy'
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import GroupsIcon from '@mui/icons-material/Groups'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ptBR } from 'date-fns/locale'

import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined'
import { Card, Container } from 'react-bootstrap'
import GaugeChart from 'react-gauge-chart'

import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { TbAssembly, TbCashBanknote } from 'react-icons/tb'
import Loader from '../../components/loader/loader'
import { useAlertMessageContext } from '../../contexts/alert-message.context'
import { usePartnerContext } from '../../contexts/partner.context'
import authService from '../../services/auth.service'
import { toStringFloat } from '../../utilities/auxiliary-functions'
import { AlertMessageEnum } from '../../utilities/types'
import { isEmpty } from '../../utilities/validators'
import DashboardHeader from '../headers/dashboard.header'
import { StripBox, StripCard } from './components/StripBox'

interface ICondominiumManagementDashboardProps {}

export const CondominiumManagementDashboard: React.FC<
  ICondominiumManagementDashboardProps
> = () => {
  let { partner } = usePartnerContext()

  const alertContext = useAlertMessageContext()

  const title = 'Gestão Condomínio'
  const description = ''

  let reloadPage: boolean = false
  const [loading, setLoading] = useState(false)

  function getRandomData() {
    return Math.floor(Math.random() * 100)
  }

  function getRandomSmallData() {
    return Math.floor(Math.random() * 10)
  }

  function getRandomValueData() {
    return Math.floor(Math.random() * 100000)
      .toFixed(2)
      .toLocaleString()
  }

  async function searchFilter() {
    if (!isEmpty(partner)) {
      try {
      } catch (error: any) {
        await alertContext.show(AlertMessageEnum.FAIL, title, error)
      }
    }
  }
  useEffect(() => {
    if (isEmpty(partner))
      // eslint-disable-next-line react-hooks/exhaustive-deps
      partner = authService.currentPartner()

    if (!reloadPage) {
      setLoading(true)
      setTimeout(() => {
        searchFilter().finally(() => {
          setLoading(false)
        })
      }, 500)
    }
  }, [])

  function viewDashboard() {
    return (
      <Container fluid className="page-body dashboards">
        <StripBox>
          <StripCard
            className="blue"
            label="Receita"
            image={<TbCashBanknote size={'48px'} />}
            value={`R$ ${toStringFloat(getRandomValueData())}`}
          />
          <StripCard
            className="cyan"
            label="Assembléia"
            image={<TbAssembly size={'48px'} />}
            value={`${getRandomData()}`}
          />
          <StripCard
            className="green"
            label="Residências"
            image={<HomeOutlinedIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
          <StripCard
            className="orange"
            label="Entregas"
            image={<LocalShippingOutlinedIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
          <StripCard
            className="reddish_pink"
            label="Carros"
            image={<TimeToLeaveIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
        </StripBox>
        <StripBox>
          <StripCard
            className="blue"
            label="Inadimplência"
            image={<CurrencyExchangeOutlinedIcon sx={{ fontSize: '48px' }} />}
            value={`R$ ${toStringFloat(getRandomValueData())}`}
          />
          <StripCard
            className="cyan"
            label="Presentes Assembléia"
            image={<EmojiPeopleIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
          <StripCard
            className="green"
            label="Ausentes Assembléia"
            image={<BoyIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
          <StripCard
            className="orange"
            label="Moradores"
            image={<GroupsIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
          <StripCard
            className="reddish_pink"
            label="Visitantes"
            image={<GroupAddIcon sx={{ fontSize: '48px' }} />}
            value={`${getRandomData()}`}
          />
        </StripBox>
        <div className="d-flex justify-content-end mb-4">
          <LocalizationProvider
            adapterLocale={ptBR}
            dateAdapter={AdapterDateFns}
          >
            <DesktopDatePicker
              label="Visão mensal"
              views={['year', 'month']}
              sx={{ minWidth: 160, fontSize: 42 }}
              slotProps={{
                textField: {
                  variant: 'standard'
                }
              }}
              className="mt-2 me-3"
            />
          </LocalizationProvider>
        </div>
        <Box className="d-flex justify-content-between gap-2">
          <Card className="flex-grow-1">
            <Card.Header>
              <Card.Title>INDICADORES</Card.Title>
            </Card.Header>
            <Card.Body>
              <Box className="d-flex justify-content-between gap-2">
                <div className="d-flex flex-column align-items-center">
                  <h4>Inadimplência</h4>
                  <GaugeChart
                    id="gauge-chart1"
                    style={{ height: 320, width: 250 }}
                    colors={['#FFC371', '#FF5F6D']}
                    arcWidth={0.3}
                    percent={getRandomData() / 100}
                    textColor="#FFFFFF"
                    needleColor="#FFFFFF"
                    needleBaseColor="#FFFFFF"
                    formatTextValue={value => `${value}%`}
                    animate
                  />
                </div>
                <div className="d-flex flex-column align-items-center">
                  <h4>Média Inadimplência</h4>
                  <GaugeChart
                    id="gauge-chart1"
                    style={{ height: 320, width: 250 }}
                    colors={['#FFC371', '#FF5F6D']}
                    arcWidth={0.3}
                    percent={getRandomData() / 100}
                    textColor="#FFFFFF"
                    needleColor="#FFFFFF"
                    needleBaseColor="#FFFFFF"
                    formatTextValue={value => `${value}%`}
                    animate
                    nrOfLevels={5}
                  />
                </div>
                <div className="d-flex flex-column align-items-center">
                  <h4>Presentes Assembléia</h4>
                  <GaugeChart
                    id="gauge-chart1"
                    style={{ height: 320, width: 250 }}
                    colors={['#FF5F6D', '#008000']}
                    arcWidth={0.3}
                    percent={getRandomData() / 100}
                    textColor="#FFFFFF"
                    needleColor="#FFFFFF"
                    needleBaseColor="#FFFFFF"
                    formatTextValue={value => `${value}%`}
                    animate
                    nrOfLevels={8}
                  />
                </div>
                <div className="d-flex flex-column align-items-center">
                  <h4>Ausentes Assembléia</h4>
                  <GaugeChart
                    id="gauge-chart1"
                    style={{ height: 320, width: 250 }}
                    colors={['#008000', '#FF5F6D']}
                    arcWidth={0.3}
                    percent={getRandomSmallData() / 100}
                    textColor="#FFFFFF"
                    needleColor="#FFFFFF"
                    needleBaseColor="#FFFFFF"
                    formatTextValue={value => `${value}%`}
                    animate
                    nrOfLevels={10}
                  />
                </div>
              </Box>
            </Card.Body>
          </Card>
        </Box>
      </Container>
    )
  }

  return (
    <div className="dashboard">
      <DashboardHeader title={title} description={description} />
      {loading ? <Loader /> : viewDashboard()}
    </div>
  )
}

export default CondominiumManagementDashboard

